import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "./AppProvider.tsx";
import { initSentry } from "./setupSentry.ts";
import { IS_DEBUG_ENABLED } from "./utils/environment.ts";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AppProvider>
        <App />
        {IS_DEBUG_ENABLED && <ReactQueryDevtools />}
      </AppProvider>
    </BrowserRouter>
  </StrictMode>,
);
